import React from 'react';

export const ArrowLeftIcon = ({ width = 32, height = 32, color = "#FFFEFA", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                className={className}
                d="M18.6667 9.33334L12 16L18.6667 22.6667"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};